<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" role="doc-dedication">
<p class="ded"><span aria-label="page v" epub:type="pagebreak" id="page_v" role="doc-pagebreak">To all the girls out there who want to be president one day. You can do it!</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?109fdf0c